import React, { Component } from 'react';
import ResultsNavigationButton from './ResultsNavigationButton';
import { connect } from 'react-redux';
import { selectUserResult } from 'selectors';

import { areResultsOwnedByUser } from 'selectors';

class ResultsNavigation extends Component {
  getFavoriteResultUUIDPath = () => {
    // this button should link to the favorites for the currently viewed results,
    // if we are not viewing results it should link to the user's results
    const { currentResult, currentUserResult } = this.props;
    if (currentResult) {
      return currentResult;
    } else {
      return currentUserResult;
    }
  };

  showHiddenButton = () => {
    const {
      areResultsOwnedByUser,
      currentUserResult,
      currentResult,
    } = this.props;
    return (
      // when viewing a result, check that if belongs to the user
      areResultsOwnedByUser ||
      // when NOT viewing a result, check that the current user has a result.
      (!currentResult && currentUserResult)
    );
  };

  render() {
    const { className } = this.props;
    const favoriteResultUUIDPath = this.getFavoriteResultUUIDPath();
    return (
      <React.Fragment>
        {favoriteResultUUIDPath ? (
          <ResultsNavigationButton
            path="favorite"
            className={className}
            resultUUID={favoriteResultUUIDPath}
          />
        ) : null}
        {this.showHiddenButton() && (
          <ResultsNavigationButton path="hidden" className={className} />
        )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUserResult: selectUserResult(state).uuid,
    areResultsOwnedByUser: areResultsOwnedByUser(state),
    currentUserId: state.auth.currentUserId,
    currentResult: state.currentResult,
  };
}

export default connect(mapStateToProps)(ResultsNavigation);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/ResultsNavigation.js